import { SmartForm, Pill, TipTapEditor } from "@avenueops/web-components";
import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";

interface Props {
  control: any;
  titleFormatConfig: {
    name: string;
    includeTitle: boolean;
  };
  messageFormatConfig: {
    name: string;
    useMarkdown: boolean;
  };
  formatOptions?: string[];
}

export default function SignalFormatInput({ control, titleFormatConfig, messageFormatConfig, formatOptions }: Props): JSX.Element {
  const { watch, setValue } = useFormContext();
  const titleText: string = watch(titleFormatConfig.name) ?? "";
  const aveTemplateReg = RegExp(/({{\s?\[?.+\]?\s?}})/);
  const multiWordVariable = RegExp(/((\w+\s+)+)/g);
  return (
    <div className="w-full overflow-auto">
      {titleFormatConfig.includeTitle ? (
        <>
          <SmartForm.TextInput
            name={titleFormatConfig.name}
            title="Signal Title"
            syntaxHighlight={() => {
              const textVals = titleText.split(aveTemplateReg);
              if (textVals.length === 1) {
                return titleText;
              }
              const children = textVals.map((val, i) => {
                if (i % 2 === 0) {
                  return val;
                }
                return (
                  <span key={`titleText_${i}`} className="text-green-800">
                    {val}
                  </span>
                );
              });

              return <>{children}</>;
            }}
          />
          {formatOptions && formatOptions.length > 0 ? (
            <div className="flex flex-row w-full space-x-2 mt-2 overflow-scroll">
              {formatOptions.map((option) => {
                let templatedOption = `{{${option}}}`;
                if (multiWordVariable.test(option)) {
                  templatedOption = `{{[${option}]}}`;
                }
                return (
                  <div key={option}>
                    <Pill
                      secondary
                      backgroundColor="#71982c"
                      onClick={() => {
                        setValue(titleFormatConfig.name, `${titleText}${templatedOption}`);
                      }}
                    >
                      {option}
                    </Pill>
                  </div>
                );
              })}
            </div>
          ) : null}
        </>
      ) : null}
      <Controller
        control={control}
        name={messageFormatConfig.name}
        render={({ field: { value: messageFormat, onChange: onMessageFormatChange } }) => (
          <div className="min-h-[250px] flex max-w-full">
            <TipTapEditor
              name={messageFormatConfig.name}
              showToolbar
              initialValue={messageFormat}
              onChange={onMessageFormatChange}
              templateableValues={formatOptions?.map((option) => {
                if (multiWordVariable.test(option)) {
                  return `[${option}]`;
                }
                return option;
              })}
            />
          </div>
        )}
      />
    </div>
  );
}
